import React from 'react';
import './style.scss';

export default class FAQButton extends React.Component {

  render() {
    return (
        <>
            <div className="Divider"/>
            <div className="FaqLink">
                    <a href="https://www.gojek.com/help/gosend/jenis-layanan-pengiriman/">FAQ</a>
            </div>
        </>
    );
  }
}

